import { render, staticRenderFns } from "./ProductPoolCate.vue?vue&type=template&id=def84e1a&"
import script from "./ProductPoolCate.vue?vue&type=script&lang=js&"
export * from "./ProductPoolCate.vue?vue&type=script&lang=js&"
import style0 from "./ProductPoolCate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports